
  import createMeisterIcons from '../src/createMeisterIcons';

  const Bell = createMeisterIcons("bell", [["path",{"fill":"currentColor","d":"M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0m-1.5-2c0-1.286.964-2.25 2.25-2.25a.75.75 0 0 0 0-1.5c-2.114 0-3.75 1.636-3.75 3.75a.75.75 0 0 0 1.5 0","key":"6fd7aa2045612e9baedc3ac9200bd770f0414eb1","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Bell
  